import MileageDetailsResponse, {
  MileageDetailsResponseVehicleType,
} from "../../../api/raily/mileage/details/mileage-details.response";
import VehicleType from "../../../types/vehicle-type";
import MileageDetails from "./mileage-details";

const createVehicleType = (
  type: MileageDetailsResponseVehicleType | undefined,
): VehicleType | undefined => {
  switch (type) {
    case MileageDetailsResponseVehicleType.CAR_GT_900CM3:
      return VehicleType.CAR_GT_900CM3;
    case MileageDetailsResponseVehicleType.CAR_LE_900CM3:
      return VehicleType.CAR_LE_900CM3;
    case MileageDetailsResponseVehicleType.COMPANY_OWNED:
      return VehicleType.COMPANY_OWNED;
    case MileageDetailsResponseVehicleType.MOPED:
      return VehicleType.MOPED;
    case MileageDetailsResponseVehicleType.MOTORCYCLE:
      return VehicleType.MOTORCYCLE;
    default:
      return undefined;
  }
};

const create = (response: MileageDetailsResponse): MileageDetails => {
  return {
    addressSeq: response.data.addressSeq,
    distance: response.data.distance,
    id: response.data.id,
    mileageDate: response.data.mileageDate,
    vehicleType: createVehicleType(response.data.vehicleType),
    workerCompanyId: response.data.workerCompanyId,
    workerName: response.data.workerName,
    cardNumber: response.data.cardNumber,
    commissionNumber: response.data.commissionNumber,
    mileageNumber: response.data.mileageNumber,
    acceptedDistance: response.data.acceptedDistance,
    osrmDistance: response.data.osrmDistance,
  };
};

const mileageDetailsFactory = {
  create,
};

export default mileageDetailsFactory;
